import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TypedDialog } from '@platform/dialog/dialog-v2.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { areFilesValid, FileValidationError } from '@platform/shared/utilities/file-utility';

export interface FileUploadDialogData {
  multiple?: boolean;
  invalidCharacters: string[];
  allowedFileFormats: string[];
}

export interface FileUploadDialogReturn {
  files: FileList;
}

@Component({
  selector: 'app-file-upload-dialog',
  templateUrl: './file-upload-dialog.component.html',
  styleUrls: ['./file-upload-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileUploadDialogComponent implements TypedDialog<FileUploadDialogComponent, FileUploadDialogData, FileUploadDialogReturn> {
  public validationError?: FileValidationError;

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent, FileUploadDialogReturn>,
    @Inject(MAT_DIALOG_DATA) public data: FileUploadDialogData,
  ) {}

  uploadFileList(fileList: FileList) {
    const validationResult = areFilesValid(fileList, this.data.invalidCharacters, this.data.allowedFileFormats);
    if (validationResult.valid) {
      this.dialogRef.close({
        files: fileList,
      });
    } else {
      this.validationError = validationResult.error;
    }
  }

  uploadFiles(event: Event) {
    if (event.target && 'files' in event.target && event.target.files instanceof FileList) {
      this.uploadFileList(event.target.files);
    }
  }
}
